import { render } from "./WorkSummary.vue?vue&type=template&id=2a6acb6c"
import script from "./WorkSummary.vue?vue&type=script&lang=js"
export * from "./WorkSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__